import { Skeleton } from "antd"
import React, { Suspense, lazy } from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { SEND_FOR_SIGNATURE_PERMISSION } from "../../../Esign/hooks/use-send-for-signature.ts"

const EsignComposePage = lazy(
  () => import("../../../Esign/EsignComposePage.tsx")
)

const gated = (
  <PermissionGate paths={[SEND_FOR_SIGNATURE_PERMISSION]}>
    <Suspense fallback={<Skeleton active paragraph={{ rows: 6 }} />}>
      <EsignComposePage />
    </Suspense>
  </PermissionGate>
)

export const esignRoutes: RouteObject[] = [
  { path: RoutesPaths.esign.newEnvelopePath, element: gated },
  { path: RoutesPaths.esign.envelopePath, element: gated }
]
